import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ExtraPaymentRequest } from 'src/app/models/payroll.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { PayrollService } from 'src/app/services/payroll.service';

@Component({
  selector: 'app-extra-payment',
  templateUrl: './extra-payment.component.html',
  styleUrls: ['./extra-payment.component.scss']
})
export class ExtraPaymentComponent implements OnInit {
  newExtraPayment: ExtraPaymentRequest = new ExtraPaymentRequest();
  type: number = 0;
  allPersonal = []
  contractedPersonal = [];
  numberContracted = 0;
  saving = false;

  constructor(
    private toastService: ToastrService,
    private payrollService: PayrollService
  ) {

  }

  ngOnInit(): void {
    this.getContracted();
  }

  getContracted() {
    this.payrollService.getContracted().subscribe({
      next: (response: ResponseObject) => {
        this.allPersonal = response.data;
        this.contractedPersonal = response.data;
        this.changeNumber();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  filter(event: any) {
    this.contractedPersonal = this.allPersonal.filter((p) => {
      return (p.identificacion + " " + p.nombre).toLowerCase().includes(event.target.value.toLowerCase())
    });
  }

  changeNumber() {
    var selected = 0;
    this.allPersonal.forEach((c) => {
      selected += c['selected'] ? 1 : 0;
    });
    this.numberContracted = selected;
  }

  saveExtraPayment() {
    var idEmployees = [];
    this.allPersonal.forEach((c) => {
      if (c['selected']) {
        idEmployees.push(c.id);
      }
    })
    this.newExtraPayment.employees = idEmployees;
    this.saving = true;
    this.payrollService.saveExtraPayment(this.type, this.newExtraPayment).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Pago creado con exito!");
        this.saving = false;
        this.reset();
      },
      error: (error: HttpErrorResponse) => {
        this.saving = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  reset() {
    this.newExtraPayment = new ExtraPaymentRequest();
    this.contractedPersonal = [];
    this.allPersonal = [];
    this.numberContracted = 0;
    this.type = 0;
    this.getContracted();
  }
}
